var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderDelivered = function SvgOrderDelivered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.842 7.118 16.483 5.76l-6.086 6.091 1.358 1.359 6.087-6.092Zm4.075-1.358L11.75 15.922l-4.003-4.004-1.358 1.359 5.361 5.361 11.52-11.52-1.353-1.358ZM.96 13.277l5.362 5.361L7.68 17.28l-5.362-5.362L.96 13.277Z",
    fill: "#27AE60"
  })));
};
export default SvgOrderDelivered;